import { Outlet, Navigate } from "react-router-dom";

const ProtectedRoutes = () => {
    return  localStorage.getItem("token")!=null && localStorage.getItem("token").length>0 ? <Outlet/> : <Navigate to="/login"/>;
}

export default ProtectedRoutes;